import React, { useEffect } from "react";
import Donations from "./components/Donations";
import Home from "./components/Home";
import WhyShowAds from "./components/WhyShowAds";
import Delete from "./components/AccountDeletion";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import UniversityResponse from "./components/UniversityResponse";
import Premium from "./components/Premium";
import {PrivacyPolicy, TermsOfService} from "./components/PrivacyPolicy";
import { ThemeProvider } from "./contexts/ThemeContext";
import ThemeToggle from "./components/ThemeToggle";
import StarField from "./components/StarField";
import SpaceTraffic from "./components/SpaceTraffic";
import { HelmetProvider } from "react-helmet-async";

const ThemeToggleWrapper = () => {
    const location = useLocation();
    if (location.pathname === '/') return null;
    return <ThemeToggle />;
};

const App = () => {
    useEffect(() => {
        const wrapHue = (h) => ((h % 360) + 360) % 360;
        const hueDistance = (a, b) => {
            const d = Math.abs(wrapHue(a) - wrapHue(b));
            return Math.min(d, 360 - d);
        };

        const softHslFromHue = (hue) => {
            const saturation = 18; // very low saturation for subtle colors
            const lightness = 70; // soft and readable
            return `hsl(${wrapHue(hue)} ${saturation}% ${lightness}%)`;
        };

        const pickNewHue = (lastHue) => {
            let attempts = 0;
            let h = Math.floor(Math.random() * 360);
            while (lastHue != null && hueDistance(h, Number(lastHue)) < 30 && attempts < 10) {
                h = (h + 47) % 360; // jump by prime-ish step to quickly escape
                attempts += 1;
            }
            return h;
        };

        const attachBlinkColorCycler = (el) => {
            if (!el) return;
            const setColors = () => {
                const lastHue = el.dataset.lastHue != null ? Number(el.dataset.lastHue) : null;
                const hue1 = pickNewHue(lastHue);
                const hue2 = hue1 + 48 + (Math.random() * 20 - 10); // different within cycle
                el.dataset.lastHue = String(hue1);
                el.style.setProperty('--blink-color-1', softHslFromHue(hue1));
                el.style.setProperty('--blink-color-2', softHslFromHue(hue2));
            };
            const maybeSet = () => {
                const isLight = document.body.classList.contains('light');
                if (isLight) return; // disable in light mode
                setColors();
            };
            maybeSet();
            const handler = () => maybeSet();
            el.addEventListener('animationiteration', handler);
            return () => el.removeEventListener('animationiteration', handler);
        };

        const elements = [...document.querySelectorAll('#blink, .blink')];
        const cleanups = elements.map(attachBlinkColorCycler).filter(Boolean);
        return () => cleanups.forEach((fn) => fn && fn());
    }, []);

    return (
        <HelmetProvider>
            <ThemeProvider>
                <Router>
                    <StarField />
                    <SpaceTraffic />
                    <ThemeToggleWrapper />
                    <Routes>
                        <Route exact path="/" element={<Home/>}></Route>
                        <Route exact path="/deleteAccount" element={<Delete/>}></Route>
                        <Route exact path="/donate" element={<Donations/>}></Route>
                        <Route exact path="/ads" element={<WhyShowAds/>}></Route>
                        <Route exact path="/premium" element={<Premium/>}></Route>
                        <Route exact path="/university_response" element={<UniversityResponse/>}></Route>
                        <Route exact path="/privacy_policy" element={<PrivacyPolicy/>}></Route>
                        <Route exact path="/terms_of_service" element={<TermsOfService/>}></Route>
                    </Routes>
                </Router>
            </ThemeProvider>
        </HelmetProvider>
    );
};

export default App;
